import { MonthSelect } from "@/components/shared/MonthSelect";
import { monthsAroundToday } from "@/lib/month-options";
import type { ReportRange } from "@/lib/report-hours";

/** Up to 24 months either side of today; the server refuses a span over 24 months. */
const OPTIONS = monthsAroundToday({ back: 24, ahead: 24 });

/**
 * From / To month pickers for an hours report. Picking a To before the From, or a span
 * over 24 months, falls back to the default range server-side (6 back, 6 forward).
 */
export function ReportRangePicker({
  range,
  onChange,
}: {
  range: ReportRange;
  onChange: (next: ReportRange) => void;
}) {
  return (
    <div className="flex items-center gap-1.5 text-sm text-muted-foreground">
      <MonthSelect
        aria-label="From month"
        size="sm"
        value={range.from}
        options={OPTIONS}
        onValueChange={(from) => onChange({ ...range, from })}
      />
      <span aria-hidden>–</span>
      <MonthSelect
        aria-label="To month"
        size="sm"
        value={range.to}
        options={OPTIONS}
        onValueChange={(to) => onChange({ ...range, to })}
      />
    </div>
  );
}
